import { createElement } from 'react';
import { Radio } from '@alifd/next';
import './index.scss';
const OadpRadio = function OadpRadio({ id, name, defaultChecked, label, disabled, ...otherProps }) {
    return (createElement(Radio, Object.assign({ id: id, name: name, defaultChecked: defaultChecked, label: label, disabled: disabled }, otherProps)));
};
export default OadpRadio;
